var App = App || {};
App.Initialization = App.Initialization || {};

App.Initialization['component.footer'] = (function () {
    'use strict';

    const initialize = (component) => {
        App.Helpers.initializeRoutingCopy(component);
        initializeNewsletterValidation(component);
    };

    const initializeNewsletterValidation = (component) => {
        const form = component.querySelector('.footer-news-letter form');
        if (!form) {
            return;
        }

        const wrapper = form.closest('.form-wrapper');
        const info = wrapper.querySelector('.info');
        const success = wrapper.querySelector('.newsletter-success');
        const input = form.querySelector('input[name="email"]');
        const feedback = form.querySelector('.invalid-feedback');
        const submitButton = form.querySelector('[type="submit"]');
        const defaultFeedback = feedback.textContent;

        const showError = (message) => {
            feedback.textContent = message || defaultFeedback;
            input.classList.add('is-invalid');
            input.setAttribute('aria-invalid', 'true');
            input.focus();
        };

        // The pattern attribute can't express dot placement; mirror the server's local-part rules
        const validateLocalPart = () => {
            const localPart = input.value.trim().split('@')[0];
            const badDots = localPart.startsWith('.') || localPart.endsWith('.') || localPart.includes('..');
            input.setCustomValidity(badDots || localPart.length > 64 ? defaultFeedback : '');
        };

        input.addEventListener('input', () => {
            input.classList.remove('is-invalid');
            input.removeAttribute('aria-invalid');
            feedback.textContent = defaultFeedback;
            validateLocalPart();
        });

        form.addEventListener('submit', async (event) => {
            event.preventDefault();
            event.stopPropagation();

            input.value = input.value.trim();
            validateLocalPart();

            if (!form.checkValidity()) {
                form.classList.add('was-validated');
                // WCAG 3.3.1 / 4.1.2: expose the error state, not just the red border
                input.setAttribute('aria-invalid', 'true');

                const firstInvalidField = form.querySelector(':invalid');
                firstInvalidField?.focus();
                return;
            }

            form.classList.remove('was-validated');
            submitButton.disabled = true;

            try {
                const response = await fetch(form.action, {
                    method: 'POST',
                    headers: { 'Accept': 'application/json' },
                    body: new FormData(form)
                });
                const result = await response.json().catch(() => ({}));

                if (!response.ok) {
                    showError(result.error);
                    return;
                }

                form.hidden = true;
                info.hidden = true;
                success.hidden = false;
            } catch {
                showError('We couldn\'t complete your signup. Please try again later.');
            } finally {
                submitButton.disabled = false;
            }
        });
    };

    return {
        initialize
    };
})();
